import { SharedModule } from '../../shared/shared.module';
import { PartenaireNewComponent } from './partenaire-new/partenaire-new.component';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PartenairesComponent } from './partenaires.component';
import { PartenairesListComponent } from './partenaires-list/partenaires-list.component';
import { PartenairesDetailsComponent } from './partenaires-details/partenaires-details.component';
import { PartenairesDetailsModule } from './partenaires-details/partenaires-details.module';
import { PartenairesListModule } from './partenaires-list/partenaires-list.module';


@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    PartenairesDetailsModule,
    PartenairesListModule
  ],
  declarations: [PartenairesComponent, PartenaireNewComponent],
  exports: [PartenairesComponent],
  entryComponents: [PartenaireNewComponent]
})
export class PartenairesModule {}
